import label from "fragments/vendors/label"
import { gql } from "graphql-tag"

const GET_LABELS = gql`
  ${label}

  query getLabels($query: GetQueryLabels) {
    getLabels(query: $query) {
      ...Label
    }
  }
`

export default GET_LABELS
